export default __webpack_public_path__ + "static/media/expedition.a1da2937.svg";